





























import { Component } from "vue-property-decorator";
import { AppErrorVue } from "fs-pb-vue2/vueModels/app/AppErrorVue";

@Component({})
export default class AppError extends AppErrorVue {
  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }
}
